import React from "react";
import { ChevronRight, ChevronLeft } from "react-bootstrap-icons";
import { FontProps } from "../../types";
import { Spinner } from "../Spinner";

type ButtonType = "primary" | "secondary";

export type NavigationButtonProps = {
  icon?: boolean;
  className?: string;
  text: string;
  navigateToDestination: () => void;
  type?: ButtonType;
  isLoading?: boolean;
  href?: string;
  isExternal?: boolean;
  disabled?: boolean;
} & FontProps;

export const NavigationButton: React.FC<NavigationButtonProps> = (props) => {
  const fontWeight = props.fontWeight ?? "";
  const fontStyle = props.fontStyle ?? ""; // "normal" is the default font-style so there is no need to specify this, also to prevent style clash with font-weight
  let buttonClassName: string;
  const isLoading = props?.isLoading === true;
  const disabledButton =
    props.disabled === true
      ? "bg-gray-300 active:!bg-gray-300 focus:!bg-gray-300 hover:!bg-gray-300 active:!border-none"
      : "";

  switch (props.type) {
    case "primary":
    case undefined:
      buttonClassName = "primary-button";
      break;
    case "secondary":
      buttonClassName = "secondary-button";
      break;
    default: {
      // const _exhaustiveCheck: ButtonType = props.type;
      return undefined;
    }
  }

  const fontWeightClass = fontWeight ? `font-${fontWeight}` : "";
  const fontStyleClass = fontStyle ? `font-${fontStyle}` : "";
  const handleNavigate = () => {
    if ((props.isExternal ?? false) && props.href !== undefined) {
      window.location.href = props.href;
    } else props.navigateToDestination();
  };

  return (
    <div className={props.className}>
      <button
        className={buttonClassName + " " + disabledButton}
        type="button"
        onClick={handleNavigate}
        disabled={isLoading || props.disabled}
      >
        <span className="flex items-center font-semibold">
          {props.icon != null && props.type === "secondary" ? (
            <ChevronLeft />
          ) : null}

          <span
            className={`btn-text col-auto ${fontWeightClass} ${fontStyleClass} whitespace-nowrap`}
          >
            {isLoading && props.type === "primary" ? <Spinner /> : props.text}
          </span>
          {props.icon != null && props.type === "primary" && !isLoading ? (
            <ChevronRight />
          ) : null}
        </span>
      </button>
    </div>
  );
};
